import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { WallboardViewService } from '../wallboard-view.service';
import { WallboardsService } from '../../wallboards.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { TopModuleDataObj, WVBase, WVMain } from '../wallboard-view.model';
import { LeaderboardSetupObj } from '../../wallboards.model';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';

@Component({
    selector: 'cv-wallboard-view-leaderboard',
    templateUrl: './wallboard-view-leaderboard.component.html',
    styleUrls: ['./wallboard-view-leaderboard.component.scss']
})
export class WallboardViewLeaderboardComponent implements OnInit, OnDestroy {
    @Input() firstSlide: boolean;

    public wvf: WVMain;
    public wvlf: WVBase;
    public leaderboardData: TopModuleDataObj[];
    public leaderboardState: LeaderboardSetupObj;
    public leaderboardMetricName: string = "Metric";

    public selectedAgent: number = 0;
    private innerTransitions: number = 0;
    private initialLoadTime = 0;
    public localization: Map<string, string>;

    private updateTimerRef: NodeJS.Timeout = null;
    private isDestroyed: boolean = false;
    private _hasBackdrop: boolean = false;
    private _hasTotalsRow: boolean = false;
    private _hasPagination: boolean = false;
    private _moduleKey: string = "";
    private _backgroundID: number = 0;
    private _wallboardID: number = 0;
    private _nextSlideID: number = 0;

    get hasBackdrop(): boolean {
        return this._hasBackdrop;
    }

    get hasTotalsRow(): boolean {
        return this._hasTotalsRow;
    }

    get hasPagination(): boolean {
        return this._hasPagination;
    }

    get moduleKey(): string {
        return this._moduleKey;
    }

    get backgroundID(): number {
        return this._backgroundID;
    }

    get itemCount(): number {
        const count = this.leaderboardData?.length || 0;
        return Math.min(count, 10);
    }

    constructor(
        private service: WallboardViewService,
        public wallboardsService: WallboardsService,
        public config: CvConfigurationService,
        private cvLocalizationService: CVLocalizationService,
        private elem: ElementRef,
    ) { }

    ngOnInit(): void {
        this.wvf = this.service.WVMain;
        this.wvlf = this.service.WVLeaderboard;

        this._hasBackdrop = this.wvlf?.Slide.HasBackdrop ?? false;
        this._hasTotalsRow = this.wvlf?.Slide.HasTotalsRow ?? false;
        this._hasPagination = this.wvlf?.Slide.HasPagination ?? false;
        this._moduleKey = this.wvlf?.Slide.WallboardModuleDetails[0].WallboardModuleKey ?? "";
        this._backgroundID = this.wvlf?.Slide.BackgroundImageID ?? 0;
        this._wallboardID = this.wvlf?.Slide.WallboardID ?? 0;
        this._nextSlideID = this.wvlf?.Slide.WallboardModuleDetails[0].WallboardSlideID ?? 0;

        this.cvLocalizationService.GetSection("WallboardViewLeadership").then(response => {
            this.localization = response;
        });

        this.wvf.RunSlide = this.firstSlide;

        let startTime = performance.now();

        this.wallboardsService.loadTypeState(1, this.moduleKey, this.wvf.WallboardCreatorID).then(response => {
            if (this.isDestroyed)
                return;

            this.leaderboardState = response.Leaderboard_Setup;

            this.service.getLeaderboardModuleData(this.wvlf.Slide.WallboardID, this.leaderboardState.LeaderboardCount, this.moduleKey).then(response => {
                if (this.isDestroyed)
                    return;

                this.leaderboardData = response;

                let endTime = performance.now();
                this.initialLoadTime = endTime - startTime;

                if (this.firstSlide)
                    this.wvf.FirstSlideReady = true;
                else
                    this.wvf.NextSlideReady = true;

                this.runSlide();
            });
        });

        this.service.getMetricName(this.wvlf.Slide.WallboardID, this.moduleKey).then(response => {
            if (this.isDestroyed)
                return;

            this.leaderboardMetricName = response;
        });
    }

    ngOnDestroy(): void {
        if (this.updateTimerRef != null)
            clearInterval(this.updateTimerRef);

        this.isDestroyed = true;
    }

    /**
     * Starts animation if slide is ready. If it is not ready, then it will wait 1000ms and try again.
     */
    public runSlide() {
        if (this.isDestroyed)
            return;

        if (!this.updateTimerRef) {
            this.updateTimerRef = setInterval(() => {
                this.service.getLeaderboardModuleData(this.wvlf.Slide.WallboardID, this.leaderboardState.LeaderboardCount, this.moduleKey).then(response => {
                    if (this.isDestroyed || this.wvf.RunSlide)
                        return;

                    this.leaderboardData = response;
                });
            }, WallboardViewService.HISTORICAL_DATA_REFRESH_INTERVAL);
        }

        if (this.wvf.RunSlide) {
            setTimeout(() => {
                if (this.updateTimerRef != null)
                    clearInterval(this.updateTimerRef);

                this.animateRowEntry();
            }, 0);
        }
        else {
            setTimeout(() => {
                this.runSlide();
            }, 1000);
        }
    }

    /**
     * Sets up the enter animations for all data rows in leaderboardData with the correct delay for each. Triggers innerSlideTransition when all rows are done.
     */
    public animateRowEntry() {
        for (let i = 0; i < this.leaderboardData.length; i++) {
            setTimeout(() => {
                $(`.wallboardViewSlide[mid=${this.moduleKey}]:first`).find("#pos" + i).slideDown(400);
                $(`.wallboardViewSlide[mid=${this.moduleKey}]:first`).find("#name" + i).slideDown(400);
                $(`.wallboardViewSlide[mid=${this.moduleKey}]:first`).find("#data" + i).slideDown(400);

                if (i == this.leaderboardData.length - 1) {
                    this.innerSlideTransition();

                    let $p = $(`.wallboardViewSlide[mid=${this.moduleKey}]:first`).find(".leaderboardRow")[0];
                    $(`.wallboardViewSlide[mid=${this.moduleKey}]:first`).find(".lRowHighlight").css({ "top": $p?.offsetTop, "width": $p?.clientWidth + 15, "height": $p?.clientHeight });
                }
            }, 500 * i);
        }
    }

    /**
     * Handles animation of the row highlight.
     */
    public innerSlideTransition() {
        this.innerTransitions++;

        if (this.innerTransitions < this.leaderboardData.length) {
            setTimeout(() => {
                let $p = this.elem.nativeElement.querySelectorAll('.leaderboardRow')[this.innerTransitions];
                $(`.wallboardViewSlide[mid=${this.moduleKey}]:first`).find(".lRowHighlight").css("top", $p?.offsetTop);
                $(`.wallboardViewSlide[mid=${this.moduleKey}]:first`).find(".lImageBackground").css({ "-webkit-animation": "flip 0.5s", "animation": "flip 0.5s" });

                setTimeout(() => {
                    this.selectedAgent++;
                    setTimeout(() => {
                        $(`.wallboardViewSlide[mid=${this.moduleKey}]:first`).find(".lImageBackground").css({ "-webkit-animation": "flipToNew 0.5s", "animation": "flipToNew 0.5s" });
                    }, 0);
                }, 500);

                this.innerSlideTransition();
            // Transition time is (length of slide - .5s for each row to render - time to load data) / number of rows
            // However, problems have been seen with large values of initialLoadTime, so it's removed for now.
            //}, ((this.wvf.Slides[this.wvf.CurrentSlide].SlideInterval * 1000) - (500 * this.leaderboardData.length) - this.initialLoadTime) / this.leaderboardData.length);
            }, ((this.wvf.Slides[this.wvf.CurrentSlide].SlideInterval * 1000) - (500 * this.leaderboardData.length)) / this.leaderboardData.length);
        }
    }

    public displayPosition(index) {
        return this.localization?.get(`Leader_Board_${index + 1}_Place`);
    }

    public getBackgroundSize() {
        if (!this.leaderboardData || this.selectedAgent > this.leaderboardData.length - 1)
            return `cover`;

        return this.leaderboardData?.[this.selectedAgent].useAvatar ? `contain` : `cover`;
    }

    public getUserImage(index) {
        if (!this.leaderboardData || index > this.leaderboardData.length - 1)
            return `url(../Admin/ImageResizer.aspx?imgid=-2&w=500&h=500)`;

        if (this.leaderboardData[index].useAvatar)
            return `url(../Admin/AvatarProfileImage.aspx?loginid=${this.leaderboardData[index].imgID}&w=397&h=500)`;
        else
            return `url(../Admin/ImageResizer.aspx?imgid=${this.leaderboardData[index].imgID || '-2'}&w=500&h=500)`;
    }

    public getIconUrl(rankIndex: number): string {
        const rankIcons = [
            "../App_Themes/CXone/icons/strong-first-rank.svg#strong-first-rank",
            "../App_Themes/CXone/icons/strong-second-rank.svg#strong-second-rank",
            "../App_Themes/CXone/icons/strong-third-rank.svg#strong-third-rank"
        ];
    
        return rankIcons[rankIndex] ?? '';
    }
    
}
